import React from "react";

import ViewAppBar from "../views/ViewAppBar";

import ViewFooter from "../views/ViewFooter";
import ContatoZap from "../components/ContatoZap";
import ViewPagamentoVenda from "../views/ViewPagamentoVenda";
import ViewAgradecimentos from "../views/ViewAgradecimentos";





const Agradecimentos: React.FC = () => (
  <>
    <ContatoZap />
    <div>
      <ViewAppBar />

      <ViewAgradecimentos/>
      

      <ViewFooter />
    </div>
  </>
);
export default Agradecimentos;

